/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Users } from "lucide-react";
import LoadingCircle from "../../components/Common/LoadingCircle";
import LandingPageHeader from "../../components/LandingPage/LandingPageHeader";
import SpeakerCard from "../../components/Speaker/SpeakerCard"; 
import NavigationButton from "../../components/Common/NavigationButton";
import { getDataByAll } from "../../api/speakerApi";

const Speaker = ({ bgColor = "bg-white"}) => {
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    getDataByAll().then((res) => {
      if (isMounted && res) {
        const limitedData = res.slice(0, 4);
        setDatas(limitedData);
        setLoading(false);
      }
    });
    return () => { isMounted = false; };
  }, []);

  if (loading) {
    return (
      <section className="py-10 flex justify-center min-h-[200px]">
        <LoadingCircle size="lg" />
        <p className="mt-4 text-slate-400 font-mono text-[10px] uppercase tracking-widest animate-pulse">
          Retrieving Data...
        </p>
      </section>
    );
  }

  return (
    <section id="speaker" className={`py-6 md:py-10 scroll-mt-24 lg:scroll-mt-44 ${bgColor}`}>
      <div className="max-w-7xl mx-auto px-4">      
        {/* Header Section */}
        <LandingPageHeader 
          icon={Users} 
          title="Our Speakers" 
          subtitle="Experts & Innovators" 
          center={false} 
        />

        {/* Card Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {datas.map((items, index) => (
            <SpeakerCard key={items.id} speaker={items} index={index} />
          ))}
        </div>

        {/* Navigation Section */}
        <NavigationButton 
          text="View Full List" 
          to="/speakers" 
          color="#0F172A" 
          variant="solid" 
          className="mt-10 md:mt-12"
        />
      </div>
    </section>
  );
};

export default Speaker;